import { createWebHistory, createRouter } from 'vue-router';
import HomePage from '@/pages/HomePage.vue';
import WorkspacePage from '@/pages/WorkspacePage.vue';
import DevicesPage from '@/pages/DevicesPage.vue';

import DebugView from '@/views/Workspace/DebugView.vue'
import TSAView from '@/views/Workspace/TSAView.vue'
import WaylineLibraryView from '@/views/Workspace/WaylineLibraryView.vue'
import TaskView from "@/views/Workspace/TaskView.vue"
import TaskView2 from "@/views/Workspace/TaskView2.vue"
import CalendarView from '../views/Workspace/CalendarView.vue';
import CalendarNext from '../views/Workspace/CalendarNext.vue';
import ToolsView from '../views/Workspace/components/tools/ToolsView.vue';
const routes = [
	{
		path: '/',
		name: 'HomePage',
		component: HomePage,
	},
    {
        path: '/workspacerc',
        name: 'Workspace RC',
        component: HomePage,
    },
    {
        path: '/workspace',
        name: 'Workspace',
        component: WorkspacePage,
        redirect: '/tsa',
        children: [
            {
                path: '/debug',
                name: 'Debug',
                component: DebugView,
                                
            },
            {
                path: '/tsa',
                name: 'TSA',
                component: TSAView,
            },
            {
                path: '/waylines',
                name: 'WaylineLibrary',
                component: WaylineLibraryView
            },
            {
                path: '/tasks',
                name: 'Tasks',
                component: TaskView
            },
            {
                path: '/tasks2',
                name: 'Tasks2',
                component: TaskView2
            },
            {
                path: '/calendar',
                name: 'Calendar',
                component: CalendarView
            },
            {
                path: '/calendar2',
                name: 'Calendar2',
                component: CalendarNext
            },
            {
                path: '/tools',
                name: 'Tools',
                component: ToolsView
            }
        ]
    },
    {
        path: '/devices',
        name: 'Devices',
        component: DevicesPage,
    }
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});


export default router;